<div><div class="t-lg white"><span>This team is</span><b> uninstalled.</b><span> They'll be forced to reinstall before taking action.</span></div></div>